<div class="container mt-4">
  <div class="row">
    <div class="col-5"></div>
    <div class="col-2">
      <div *ngIf="loader == true">
        <app-loader style="text-align: center"></app-loader>
      </div>
    </div>
    <div class="col-5"></div>
  </div>
    <div class="row justify-content-center">
      <!-- Card for $100 -->
      <div
        class="col-3 card text-center mx-3 p-3 selectable-card"
        [ngClass]="{ 'border-primary': amount === 100 }"
        (click)="selectValue(100)"
      >
        <h5 class="card-title"><b class="b">$100</b></h5>
      </div>
  
      <!-- Card for $200 -->
      <div
        class="col-3 card text-center mx-3 p-3 selectable-card cardheight"
        [ngClass]="{ 'border-primary': amount === 200 }"
        (click)="selectValue(200)"
      >
        <h5 class="card-title"><b style="font-size: 30px;">$200</b></h5>
      </div>

      <div
      class="col-3 card text-center mx-3 p-3 selectable-card"
      [ngClass]="{ 'border-primary': amount === 300 }"
      (click)="selectValue(300)"
    >
      <h5 class="card-title"><b style="font-size: 30px;">$300</b></h5>
    </div>
    <div
    class="col-3 card text-center mx-3 p-3 selectable-card"
    [ngClass]="{ 'border-primary': amount === 400 }"
    (click)="selectValue(400)"
  >
    <h5 class="card-title"><b style="font-size: 30px;">$400</b></h5>
  </div>
  <div
  class="col-3 card text-center mx-3 p-3 selectable-card"
  [ngClass]="{ 'border-primary': amount === 500 }"
  (click)="selectValue(500)"
>
  <h5 class="card-title"><b style="font-size: 30px;">$500</b></h5>
</div>
<div
class="col-3 card text-center mx-3 p-3 selectable-card"
[ngClass]="{ 'border-primary': amount === 600 }"
(click)="selectValue(600)"
>
<h5 class="card-title"><b style="font-size: 30px;">$600</b></h5>
</div>
    </div>
  
    <!-- Textbox to show the selected value -->
    <div class="mt-4 text-center">
      <input style="font-size: 20px; height: 40px; font-style: bold;"
        type="text"
        class="form-control d-inline-block w-25"
        placeholder="Selected Value"
        [(ngModel)]="amount"
        
      />
    </div>
    <div class="mt-4 text-center" >
        <button (click)="checkout()" class="btn btn-success btn-lg">Checkout</button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button class="btn btn-danger btn-lg" mat-button (click)="closeDialog()">Close</button>
      </div>
      
  </div>
  